import { RES_DOMAIN } from 'constant/config';
import React, { useEffect, useRef, useState } from 'react';
import AdPlayerModal from './AdPlayerModal';
import { isMobile } from 'react-device-detect';

const AdThumb = ({ src, alt = 'Ad Thumbnail', videoUrl, handleMoAdClick = () => {}, adUrl, trackingEvents, clickLogUrl }) => {
    const [imgError, setImgError] = useState(false);
    const [isOpened, setIsOpened] = useState(false);
    const lottieContainerRef = useRef(null);
    const lottieInstanceRef = useRef(null); // Lottie 인스턴스 추적

    const handleVodImageError = () => setImgError(true);
    const handleClose = () => setIsOpened(false);

    const handleAdClick = (e) => {
        e.preventDefault(); // 기본 동작 방지
        if (isMobile) {
            handleMoAdClick();
        } else {
            setIsOpened(true);
        }
    };

    useEffect(() => {
        if (lottieContainerRef.current && window.bodymovin) {
            // Lottie 애니메이션 초기화
            lottieInstanceRef.current = window.bodymovin.loadAnimation({
                container: lottieContainerRef.current,
                renderer: 'svg',
                loop: false,
                autoplay: true,
                path: `${RES_DOMAIN}/images/lottie/a_d_play.json`,
            });
        }

        return () => {
            // 이전 애니메이션 제거
            if (lottieInstanceRef.current) {
                lottieInstanceRef.current.destroy();
                lottieInstanceRef.current = null;
            }
        };
    }, [lottieContainerRef]);

    return (
        <>
            <a className="thum" onClick={handleAdClick} href={isMobile ? adUrl || '#' : 'javascript:void(0)'}>
                {imgError ? (
                    <span className="thumb-default">썸네일</span>
                ) : (
                    <>
                        <img
                            src={src}
                            alt={alt}
                            onError={handleVodImageError}
                            loading="lazy"
                            className="ad-thumb-image"
                        />
                        <span className="a_d_play" ref={lottieContainerRef}></span>
                    </>
                )}
            </a>
            {!isMobile && (
                <AdPlayerModal
                    isOpened={isOpened}
                    handleClose={handleClose}
                    videoUrl={videoUrl}
                    adUrl={adUrl}
                    trackingEvents={trackingEvents}
                    clickLogUrl={clickLogUrl}
                />
            )}
        </>
    );
};

export default AdThumb;